import * as styles from "../../../styles/AdvicePage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import { API_BASE_URL, LoadDetailCounsel } from "../../../reduxaction/post";
import { RootState } from "../../../reducer";
import { useSelector } from "react-redux";
import postSlice from "../../../reducer/post";
import * as Commonstyles from "../../../styles/Common";
import Modal from "../../../components/Modal";
import { BsArrowReturnRight } from "react-icons/bs";
import { filestype } from "../../../reducer/postpayloadtypes";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import styled from "styled-components/macro";
dayjs.locale("ko");

const DowunLoadCon = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DowunLoadTtx = styled.div`
  padding: 10px;
  background-color: #73972c;
  border-radius: 10px;
  margin: 10px 0px;
  color: white;
  cursor: pointer;
`;
const AdviceDetail = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { DetailCounsel } = useSelector((state: RootState) => state.post);
  const { me } = useSelector((state: RootState) => state.user);

  const [serachparams] = useSearchParams();

  const [commnet, setCmomnet] = useState<string>("");
  const [replycommnet, setReplycommnet] = useState<string>("");

  const [modal, setModal] = useState<boolean>(false);
  const [deletemodal, setDeletemodal] = useState<boolean>(false);
  const [commnetdeletemodal, setCommnetdeletemodal] = useState<boolean>(false);

  const [replymodal, setReplymodal] = useState<boolean>(false);
  const [update, setUpdate] = useState<boolean>(false);

  const [parentid, setParentid] = useState<number>(0);
  const [replycommnetid, setReplycommnetid] = useState<number>(0);
  const [commnetid, setcommnetid] = useState<number>(0);

  // 수정 state

  const [uptitle, setUptitle] = useState<any>("");
  const [updescription, setUpdescription] = useState<any>("");
  const [confirmmodal, setConfirmmodal] = useState<boolean>(false);
  const [images, setImages] = useState<filestype[] | any>([]);

  const [deleteimg, setDeleteimg] = useState<string[]>([]);

  ////// 수정할 때 이미지
  const [imageSources, setImageSources] = useState<any>([]);
  const [apiImages, setapiImages] = useState<any>([]);

  useEffect(() => {
    setUptitle(DetailCounsel?.title);
    setUpdescription(DetailCounsel?.description);
  }, [DetailCounsel, update]);

  useEffect(() => {
    dispatch(LoadDetailCounsel(serachparams.get("counselId")));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      userSlice.actions.Routerpath(
        `/AdviceDetail?counselId=${serachparams.get("counselId")}`
      )
    );
  }, [dispatch]);

  useEffect(() => {
    setImages(DetailCounsel?.file);
  }, [DetailCounsel?.file, update]);
  // 수정 완료 함수
  const confirmmodalfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        if (!uptitle) {
          return confirmAlert({
            title: "제목을 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        if (!updescription) {
          return confirmAlert({
            title: "내용을 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }
        let data = {
          title: uptitle,
          description: updescription,
        };
        const response = await axios.put(
          `/ifactory/api/counsel/${DetailCounsel?.counselId}`,
          data
        );
        let datas: any = {
          fileNames: deleteimg,
        };

        const response2 = await axios.delete(`/ifactroy/api/file/deletefile`, {
          data: datas,
        });
        setapiImages([]);
        setImageSources([]);
        if (apiImages.length >= 1) {
          for (let i = 0; i < apiImages.length; i++) {
            let file = apiImages[i];

            let formData = new FormData();

            formData.append("image", file as any);

            try {
              const imageresponse = await axios.post(
                `ifactory/api/file/uploadfile/counsel/${DetailCounsel?.counselId}`,
                formData,
                {
                  headers: {
                    // Authorization: `Bearer ${AccessToken}`,
                    "Content-Type": "multipart/form-data",
                  },
                  transformRequest: (formData) => formData,
                }
              );
            } catch (error) {
              console.log("error:", error);
            }
          }
        }
        setUpdate((prev) => !prev);
        dispatch(postSlice.actions.refreshDetailCounsel(null));
        dispatch(LoadDetailCounsel(serachparams.get("counselId")));
        setDeleteimg([]);
        setConfirmmodal(false);
      } else if (type === "NO") {
        setConfirmmodal(false);
      }
    },
    [DetailCounsel, uptitle, updescription, deleteimg, apiImages]
  );

  // --------------------- 상담 게시글
  // 게시글 수정 삭제 모달
  const modalfunc = (type: string) => {
    if (type === "delete") {
      setModal(true);
    } else if (type === "adjust") {
      setUpdate(true);
    } else if (type === "cancel") {
      setUpdate(false);
    } else if (type === "confirmadjust") {
      setConfirmmodal(true);
    }
  };

  // 상담 게시글 삭제
  const deletefunc = useCallback(async (type: string) => {
    if (type === "YES") {
      const response = await axios.delete(
        `/ifactory/api/counsel/${serachparams.get("counselId")}`
      );
      navigate(-1);
    } else if (type === "NO") {
      setModal(false);
      console.log("no");
    }
  }, []);

  // --------------------- 상담 게시글 끝

  const Createday = dayjs(DetailCounsel?.regDate).format(
    "YYYY년 MM월 DD일 dddd HH시 mm분"
  );

  // ----------------------- Common

  // ---- 댓글 대댓글 값 바꾸는 함수
  const commnetchangefunc = useCallback((e: any, type: string) => {
    if (type === "comment") {
      setCmomnet(e.target.value);
    } else if (type === "reply") {
      setReplycommnet(e.target.value);
    }
  }, []);

  // 댓글 대 댓글 삭제 모달
  const modaldeletefunc = (id: number, type: string) => {
    if (type === "commnetdelete") {
      setCommnetdeletemodal(true);
      setcommnetid(id);
    } else if (type === "replycommnet") {
      setReplymodal(true);
      setParentid(id);
    } else if (type === "replydelete") {
      setDeletemodal(true);
      setReplycommnetid(id);
    }
  };

  // 댓글 대댓글 추가
  const postfunc = useCallback(
    async (type: string) => {
      if (type === "comment") {
        if (!commnet) {
          return confirmAlert({
            title: "댓글을 입력해 주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }
        let data = {
          comment: commnet,
        };
        const response = await axios.post(
          `/ifactory/api/counsel/comment/${serachparams.get(
            "counselId"
          )}`,
          data
        );

        dispatch(postSlice.actions.refreshDetailCounsel(null));
        dispatch(LoadDetailCounsel(serachparams.get("counselId")));
        setCmomnet("");
      } else if (type === "reply") {
        if (!replycommnet) {
          return confirmAlert({
            title: "대 댓글을 입력해 주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }
        let data = {
          comment: replycommnet,
          parentId: parentid,
        };
        const response = await axios.post(
          `/ifactory/api/counsel/comment/${serachparams.get(
            "counselId"
          )}`,
          data
        );

        dispatch(postSlice.actions.refreshDetailCounsel(null));
        dispatch(LoadDetailCounsel(serachparams.get("counselId")));
        setReplycommnet("");
        setReplymodal(false);
      }
    },
    [commnet, replycommnet]
  );

  // ------------------ Common  끝

  // --------------- 대 댓글 ----------------------------

  // 대 댓글 삭제

  const deletereplyfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        const response = await axios.delete(
          `/ifactroy/api/counsel/comment/${replycommnetid}`
        );
        setDeletemodal(false);

        dispatch(postSlice.actions.refreshDetailCounsel(null));
        dispatch(LoadDetailCounsel(serachparams.get("counselId")));
      } else if (type === "NO") {
        setDeletemodal(false);
      }
    },
    [parentid, replycommnetid]
  );

  // --------------- 대 댓글 끝 ----------------------------

  // ----------------- 댓글 ---------------------------

  //  댓글 삭제
  const deleteCommnetfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        const response = await axios.delete(
          `/ifactroy/api/counsel/comment/${commnetid}`
        );
        setCommnetdeletemodal(false);

        dispatch(postSlice.actions.refreshDetailCounsel(null));
        dispatch(LoadDetailCounsel(serachparams.get("counselId")));
      } else if (type === "NO") {
        setCommnetdeletemodal(false);
      }
    },
    [parentid, commnetid]
  );

  // ----------------- 댓글 끝 ---------------------------

  const changeTiDes = useCallback(
    (e: any, type: string) => {
      if (type === "uptitle") {
        setUptitle(e.target.value);
      } else if (type === "updescription") {
        setUpdescription(e.target.value);
      }
    },
    [uptitle, updescription]
  );

  const removeimagefuncsecond = useCallback(
    (image: any, idx: number) => {
      setDeleteimg([...deleteimg, image.name]);
      let copyimg = [...images];
      let InxImage = copyimg.indexOf(image);
      copyimg.splice(InxImage, 1);
      setImages([...copyimg]);
    },

    [images, deleteimg]
  );

  const onChangeImages = useCallback(
    async (e: any) => {
      const file = e.target.files[0];

      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        canvas.width = 800;
        canvas.height = 600;

        context?.drawImage(image, 0, 0, 800, 600);

        const resizedImage = canvas.toDataURL();
        setImageSources([...imageSources, resizedImage]);
      };

      setapiImages([...apiImages, file]);
    },
    [imageSources, apiImages]
  );

  const removeimagefunc = useCallback(
    (Image: string, idx: number) => {
      let copyimg = [...imageSources];
      let InxImage = copyimg.indexOf(Image);
      copyimg.splice(InxImage, 1);
      setImageSources([...copyimg]);

      let copyapiImages = [...apiImages];
      copyapiImages.splice(InxImage, 1);
      setapiImages([...copyapiImages]);
    },
    [imageSources, apiImages]
  );

  const gobacks = () => {
    navigate("/AdvicePage");
  };
  return DetailCounsel?.message === "access denied" ? (
    <styles.Goback>
      <styles.Dummy>
        <div>권한이 없습니다.</div>
        <span onClick={gobacks}>되돌아가기</span>
      </styles.Dummy>
    </styles.Goback>
  ) : (
    <styles.Container>
      <styles.PageTop2>
        <p
          className="left-arrow"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img src="./img/ArrowLeft.svg" />
        </p>

        <div>
          {me?.userId === DetailCounsel?.member.userId &&
            (update ? (
              <button
                style={{ marginRight: 14 }}
                className="delete-submit"
                onClick={() => modalfunc("confirmadjust")}
              >
                수정완료
              </button>
            ) : (
              <button
                style={{ marginRight: 14 }}
                className="delete-submit"
                // onClick={adjustfunc}
                onClick={() => modalfunc("adjust")}
              >
                수정
              </button>
            ))}
          {!update && me?.userId === DetailCounsel?.member.userId && (
            <button
              className="delete-submit"
              onClick={() => modalfunc("delete")}
            >
              삭제
            </button>
          )}
          {update && (
            <button
              className="delete-submit"
              onClick={() => modalfunc("cancel")}
            >
              취소
            </button>
          )}
        </div>
      </styles.PageTop2>

      <styles.AdviceList>
        <styles.AdviceListItem>
          <div className="advice-top">
            <p className="advice-name">{DetailCounsel?.member.userId}</p>
            <p className="advice-date">{Createday}</p>
          </div>
          {update ? (
            <styles.WriteForm>
              <div className="writeform-box">
                <p className="writeform-title">제목</p>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={uptitle}
                  onChange={(e) => changeTiDes(e, "uptitle")}
                />
              </div>
            </styles.WriteForm>
          ) : (
            <>
              <p className="advice-title">제목</p>
              <p className="advice-content">{DetailCounsel?.title}</p>
            </>
          )}
          {update ? (
            <styles.WriteForm>
              <div className="writeform-box">
                <p className="writeform-title">내용</p>
                <textarea
                  id="description"
                  name="description"
                  value={updescription}
                  onChange={(e) => changeTiDes(e, "updescription")}
                />
              </div>
            </styles.WriteForm>
          ) : (
            <>
              <p className="advice-title">내용</p>
              <p className="advice-content">{DetailCounsel?.description}</p>
            </>
          )}

          <div className="detail-img detail">
            <p className="detail-img-item">
              {images?.map((image: any, idx: any) => {
                const Downfunc = () => {
                  const link = document.createElement("a");
                  link.href = `${API_BASE_URL}/ifactroy/api/file/downloadfile/${image.name}`;
                  link.download = "modalImage.jpg";
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };

                return (
                  <>
                    {update && image && (
                      <div
                        onClick={() => removeimagefuncsecond(image, idx)}
                        style={{
                          position: "absolute",
                          right: 20,
                          fontSize: 25,
                        }}
                      >
                        x
                      </div>
                    )}
                    <DowunLoadCon>
                      <DowunLoadTtx onClick={Downfunc}>다운로드</DowunLoadTtx>
                    </DowunLoadCon>

                    <img
                      src={`${API_BASE_URL}/ifactroy/api/file/downloadfile/${image.name}`}
                    />
                  </>
                );
              })}
            </p>
          </div>

          {update && (
            <styles.ImageUpLoadBox>
              <p className="content-tit">사진</p>
              <styles.ImageUpload>
                <label htmlFor="file">
                  <div className="camera-btn">
                    <p className="camera-img">
                      <img src="./img/camera.svg" />
                    </p>
                  </div>
                </label>
                <input
                  type="file"
                  id="file"
                  accept="image/jpg, image/png, image/jpeg"
                  multiple
                  onChange={onChangeImages}
                />
                {imageSources.map((Image: any, idx: any) => {
                  return (
                    <div>
                      <styles.PreviewIamge key={`index${idx}`}>
                        <img src={Image} alt={idx} />
                        <div onClick={() => removeimagefunc(Image, idx)}>x</div>
                      </styles.PreviewIamge>
                    </div>
                  );
                })}
              </styles.ImageUpload>
            </styles.ImageUpLoadBox>
          )}

          <div className="advice-comment detail mt-25">
            {!update &&
              DetailCounsel?.comment.length &&
              DetailCounsel?.comment.length >= 1
              ? DetailCounsel?.comment.map((comment) => {
                return (
                  <div>
                    <div className="advice-wrapper">
                      <div className="advice-comment-info">
                        <p className="advice-comment-user">
                          <img src="./img/AdviceWrite.svg" />
                        </p>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <p className="advice-comment-name">
                            {comment.writer}
                          </p>

                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            {me?.userId === comment.writerId ? (
                              <p
                                style={{ marginRight: 15 }}
                                onClick={() =>
                                  modaldeletefunc(
                                    comment.commentId,
                                    "commnetdelete"
                                  )
                                }
                              >
                                삭제하기
                              </p>
                            ) : null}

                            <p
                              onClick={() =>
                                modaldeletefunc(
                                  comment.commentId,
                                  "replycommnet"
                                )
                              }
                            >
                              대댓글 달기
                            </p>
                          </div>
                        </div>
                      </div>
                      <p className="advice-comment-text">{comment.comment}</p>
                    </div>

                    <div className="replycon">
                      {/* {comment.childComment.length >= 1 && (
                        <BsArrowReturnRight size={28} />
                      )} */}
                      {comment.childComment &&
                        comment.childComment.map((reply) => {
                          return (
                            <>
                              <BsArrowReturnRight size={28} />
                              <div
                                className="advice-wrapper"
                                key={reply.commentId}
                              >
                                <div className="advice-comment-info">
                                  <p className="advice-comment-user">
                                    <img src="./img/AdviceWrite.svg" />
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <p className="advice-comment-name">
                                      {reply.writer}
                                    </p>
                                    {me?.userId === reply.writerId ? (
                                      <p
                                        // onClick={() =>
                                        //   replydelete(reply.commentId)
                                        // }

                                        onClick={() =>
                                          modaldeletefunc(
                                            reply.commentId,
                                            "replydelete"
                                          )
                                        }
                                      >
                                        삭제하기
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                                <p className="advice-comment-text">
                                  {reply.comment}
                                </p>
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>
                );
              })
              : null}
          </div>
        </styles.AdviceListItem>
        {!update && (
          <styles.AdviceComment>
            <input
              type="text"
              placeholder="댓글을 입력해 주세요."
              value={commnet}
              onChange={(e) => commnetchangefunc(e, "comment")}
            />
            <img
              src="./img/commentbtn.svg"
              onClick={() => postfunc("comment")}
            />
          </styles.AdviceComment>
        )}

        {replymodal && (
          <div>
            <Commonstyles.ModalBack
              onClick={() => setReplymodal(false)}
            ></Commonstyles.ModalBack>

            <styles.AdviceComment>
              <input
                type="text"
                placeholder="대 댓글을 입력해 주세요."
                value={replycommnet}
                onChange={(e) => commnetchangefunc(e, "reply")}
              />
              <img
                src="./img/commentbtn.svg"
                onClick={() => postfunc("reply")}
              />
            </styles.AdviceComment>
          </div>
        )}
      </styles.AdviceList>
      {modal && (
        <Modal
          title={"정말로 삭제하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deletefunc("YES")}
          secondclick={() => deletefunc("NO")}
        />
      )}

      {/* 게시글 수정 */}
      {confirmmodal && (
        <Modal
          title={"정말로 수정하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => confirmmodalfunc("YES")}
          secondclick={() => confirmmodalfunc("NO")}
        />
      )}

      {/* 대 댓글 삭제 */}
      {deletemodal && (
        <Modal
          title={"정말로 삭제하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deletereplyfunc("YES")}
          secondclick={() => deletereplyfunc("NO")}
        />
      )}

      {/* 댓글 삭제 */}
      {commnetdeletemodal && (
        <Modal
          title={"정말로 삭제하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deleteCommnetfunc("YES")}
          secondclick={() => deleteCommnetfunc("NO")}
        />
      )}
    </styles.Container>
  );
};

export default AdviceDetail;
